import * as React from "react";
import type { SvyInputProps } from "./SvyInput.interface";
import {
    Container,
    ElementLeft,
    ElementRight,
    InputContainer,
    Precision,
    StyledInput,
    StyledLabel,
    StyledHelperText,
    CustomInputContainer,
} from "./SvyInput.style";
import { SvyIcon } from "@/indicators";
import { withTooltip } from "@/helpers/withTooltip";

const Label = withTooltip(StyledLabel);

export const SvyInput = React.forwardRef<HTMLInputElement, SvyInputProps>((props, ref) => {
    const {
        placeholder,
        label,
        labelDetail,
        labelTooltip,
        elementLeft,
        elementRight,
        helperText,
        hasError,
        isFocused,
        customInput,
        ...otherProps
    } = props;

    return (
        <Container>
            {label && (
                <Label tooltip={labelTooltip}>
                    <span>{label}</span> {labelDetail && <Precision>{labelDetail}</Precision>}
                </Label>
            )}
            <InputContainer>
                {elementLeft && <ElementLeft>{elementLeft}</ElementLeft>}
                {customInput ? (
                    <CustomInputContainer
                        hasLeftElement={!!elementLeft}
                        hasRightElement={!!elementRight}
                        hasError={!!hasError}
                        isFocused={!!isFocused}
                        {...otherProps}
                    >
                        {customInput}
                    </CustomInputContainer>
                ) : (
                    <StyledInput
                        data-testid="svy-input"
                        placeholder={placeholder}
                        hasLeftElement={!!elementLeft}
                        hasRightElement={!!elementRight}
                        hasError={!!hasError}
                        isFocused={!!isFocused}
                        ref={ref}
                        {...otherProps}
                    />
                )}
                {elementRight && <ElementRight>{elementRight}</ElementRight>}
            </InputContainer>
            {helperText && (
                <StyledHelperText hasError={!!hasError}>
                    {helperText && hasError && <SvyIcon icon="alert-line" />}
                    {helperText}
                </StyledHelperText>
            )}
        </Container>
    );
});

SvyInput.displayName = "SvyInput";
